import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default Vue.prototype.$store = new Vuex.Store({
  state: {
    isWeChatBrowser: false,
    token: "",
    LOADING: false,
    //是否弹框
    showBottomNav: false,
    publishId: -1,
    // 是否可以用定位
    canIUseLocation: true
  },
  mutations: {
    set_token(state, token) {
      state.token = token
      localStorage.token = token
    },
    del_token(state) {
      state.token = ''
      localStorage.removeItem('token')
    },
    showLoading(state) {
      state.LOADING = true
    },
    hideLoading(state) {
      state.LOADING = false
    },
    showPush(state, id) {
      console.log(state)
      state.showBottomNav = true;
      state.publishId = id;
    },
    hidePush(state) {
      state.showBottomNav = false;
      state.publishId = -1;
    },
    openLocation(state) {
      state.canIUseLocation = true;
    },
    closeLocation(state) {
      state.canIUseLocation = false;
    },
  }
})



// WEBPACK FOOTER //
// ./src/store.js